// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import wixWindow from 'wix-window';

$w.onReady(function () {
	
	if ( wixWindow.formFactor === "Desktop" ) {
		$w("#image2").hide();
		$w("#text3").hide();
	
	}
	
});